export const AGENT_TYPES = {
  agent: 'Renting (via letting agent)',
  landlord: 'Renting (via landlord)',
  other: 'Home Owner',
};
